export const PREDEFINED_TENANTS = {
  SWAG: 'swag',
  SENDOSO: 'sendoso',
  POSTAL: 'postal',
  CUSTOM_INK: 'custom-ink'
};
export let OrderStorageTypes = /*#__PURE__*/function (OrderStorageTypes) {
  OrderStorageTypes["CART"] = "cart";
  OrderStorageTypes["DRAFT"] = "draft";
  return OrderStorageTypes;
}({});
export let BundleType = /*#__PURE__*/function (BundleType) {
  BundleType["SWAG"] = "swag";
  BundleType["SENDOSO"] = "sendoso";
  BundleType["POSTAL"] = "postal";
  BundleType["DYNAMIC"] = "dynamic";
  return BundleType;
}({});
export let EmailLayoutType = /*#__PURE__*/function (EmailLayoutType) {
  EmailLayoutType["SWAG"] = "swag";
  EmailLayoutType["SENDOSO"] = "sendoso";
  EmailLayoutType["POSTAL"] = "postal";
  EmailLayoutType["CUSTOM_INK"] = "custom-ink";
  EmailLayoutType["DYNAMIC"] = "dynamic";
  EmailLayoutType["CUSTOM_DYNAMIC"] = "custom-dynamic";
  EmailLayoutType["CUSTOM"] = "custom";
  return EmailLayoutType;
}({});
export let ProviderType = /*#__PURE__*/function (ProviderType) {
  ProviderType["SHOPIFY"] = "SHOPIFY";
  ProviderType["ZAPIER"] = "ZAPIER";
  ProviderType["CUSTOM_INK"] = "CUSTOM_INK";
  return ProviderType;
}({});
export let FilterIds = /*#__PURE__*/function (FilterIds) {
  FilterIds["minQuantity"] = "minQuantity";
  FilterIds["productionTime"] = "productionTime";
  FilterIds["colorFamily"] = "colorFamily";
  FilterIds["categoryId"] = "categoryId";
  FilterIds["price"] = "price";
  FilterIds["embellishmentMethod"] = "embellishmentMethod";
  FilterIds["boxAndInventory"] = "boxAndInventory";
  FilterIds["isBox"] = "isBox";
  FilterIds["isInventory"] = "isInventory";
  FilterIds["isSuperSpeed"] = "isSuperSpeed";
  FilterIds["maxPrintColors"] = "maxPrintColors";
  FilterIds["imprintLocationsAmount"] = "imprintLocationsAmount";
  FilterIds["includeSearchableOnly"] = "includeSearchableOnly";
  FilterIds["isInternationalShipping"] = "isInternationalShipping";
  return FilterIds;
}({});
export let ActionConstants = /*#__PURE__*/function (ActionConstants) {
  ActionConstants["ADD"] = "ADD";
  ActionConstants["REMOVE"] = "REMOVE";
  return ActionConstants;
}({});
export const ALL_SWAG_CATEGORY = 'all-swag';
export const BRANDS_CATEGORY = 'brands';
export const EZE_TECH_DOMAIN = 'eze.tech';
export const ALL_PRODUCTS_PREFIX = 'all-products';
export const IN_HAND_DATE_INTERVAL = 5;
export const CHANGE_MOCKUP_REQUEST_ADDITIONAL_DAYS = 3;
export const DEFAULT_PRODUCTS_PER_PAGE = 12;
export const SYSTEM = 'SYSTEM';
export const LIMIT_NAME_QUERY_RESULT = 10;
export const ITEMS_PER_PAGE = 20;
export const HOME = 'home';
export const PAST_WORK = 'pastWork';
export const BUILD_A_BOX_BUTTON_EXCLUDED_PAGES = {
  ['']: 1,
  techstars: 'techstars',
  spring: 'spring',
  wework: 'wework',
  americanunderground: 'americanunderground',
  primoprint: 'primoprint',
  industrious: 'industrious'
};
export const UPSELL_WIDGET_STATES = {
  PRODUCT_BUILDER: 'productBuilder',
  CHECKOUT: 'checkout',
  IS_QUANTITY_CHANGED: 'isQuantityChanged'
};
export const ATTACHMENT_LIMIT = 104857600;
export const FAQ_LIMIT = 1572864;
export const CATEGORY_LOGO_LIMIT = 1572864; // 1.5MB
export const GOODIE_GIVEAWAY_PRODUCT_IMAGE_LIMIT = 2097152; //2MB
export const CUSTOM_PRODUCT_LIMIT = 10485760; //10MB
export const SMA_FILE_SIZE_LIMIT = 1024 * 1024;
export const BUNDLE_TYPE_MAIN_COLORS = {
  [BundleType.SWAG]: {
    secondaryColor: '#F556A0',
    primaryColor: '#00BFFF'
  },
  [BundleType.DYNAMIC]: {
    secondaryColor: '#F556A0',
    primaryColor: '#00BFFF'
  },
  [BundleType.SENDOSO]: {
    secondaryColor: '#352e27',
    primaryColor: '#f37021'
  },
  [BundleType.POSTAL]: {
    secondaryColor: '#273444',
    primaryColor: '#29afff'
  }
};
export const TENANT_LABELS = {
  [PREDEFINED_TENANTS.CUSTOM_INK]: 'Custom Ink',
  [PREDEFINED_TENANTS.SWAG]: 'Swag',
  [PREDEFINED_TENANTS.SENDOSO]: 'Sendoso',
  [PREDEFINED_TENANTS.POSTAL]: 'Postal',
  [BundleType.DYNAMIC]: 'Dynamic'
};
const RESELLER = 'reseller';
const CUSTOM_INK = 'custom-ink';
export const TenantStoreSettingStoreTypes = {
  RESELLER,
  CUSTOM_INK
};
export const CART_LINK_PREFIX = '/cart-link/';
export const CART_LINK_PREFIX_ROUTE = `${CART_LINK_PREFIX}:cartLinkId`;